import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import { useMemo } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { useEntities } from '../../entity/useEntities/useEntities';
export function useGroupedByUserGroup(items, getUserGroupId) {
  const $ = _c(4);
  const userGroups = useEntities(EntityName.UserGroup, "getAll");
  let t0;
  if ($[0] !== getUserGroupId || $[1] !== items || $[2] !== userGroups) {
    const {
      fallbackGroup,
      availableGroups
    } = generateEmptyGroups(userGroups);
    putItemsIntoGroups({
      fallbackGroup,
      availableGroups,
      items,
      getUserGroupId
    });
    t0 = availableGroups.filter(_temp);
    $[0] = getUserGroupId;
    $[1] = items;
    $[2] = userGroups;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const groups = t0;
  return groups;
}
function _temp(g) {
  return g.items.length;
}
export type UserGroupGroup<T> = {
  userGroup: UserGroup | null;
  label: string;
  key: string;
  items: Array<T>;
};
function generateEmptyGroups<T>(userGroups: Array<UserGroup>): {
  fallbackGroup: UserGroupGroup<T>;
  availableGroups: Array<UserGroupGroup<T>>;
} {
  const fallbackGroup: UserGroupGroup<T> = {
    userGroup: null,
    label: '',
    key: 'null',
    items: []
  };
  const availableGroups: Array<UserGroupGroup<T>> = [...userGroups.map<UserGroupGroup<T>>(userGroup => ({
    userGroup,
    label: userGroup.name,
    key: EntityUtils.getTrackingKey(userGroup),
    items: []
  })), fallbackGroup];
  return {
    fallbackGroup,
    availableGroups
  };
}
function putItemsIntoGroups<T>({
  fallbackGroup,
  availableGroups,
  items,
  getUserGroupId
}: {
  fallbackGroup: UserGroupGroup<T>;
  availableGroups: Array<UserGroupGroup<T>>;
  items: Array<T>;
  getUserGroupId: (item: T) => string;
}): void {
  for (const item of items) {
    const userGroupId = getUserGroupId(item);
    const availableGroup = availableGroups.find(g => g.userGroup?.id === userGroupId);
    if (availableGroup) {
      availableGroup.items.push(item);
    } else {
      fallbackGroup.items.push(item);
    }
  }
}